var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSideShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.54407 14.7114C3.29742 14.958 3.29742 15.3579 3.54407 15.6046C3.79072 15.8512 4.19061 15.8512 4.43726 15.6046L7.59515 12.4467C7.8418 12.2 7.8418 11.8001 7.59515 11.5535L4.43726 8.39559C4.19061 8.14894 3.79072 8.14894 3.54407 8.39559C3.29742 8.64224 3.29742 9.04213 3.54407 9.28878L6.25537 12.0001L3.54407 14.7114Z",
    fill: "#3F3F3F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.35907 24H21.0433C22.7873 24 24.2012 22.5862 24.2012 20.8421V3.15789C24.2012 1.41384 22.7873 0 21.0433 0H3.35907C1.61501 0 0.201172 1.41384 0.201172 3.15789V20.8421C0.201172 22.5862 1.61501 24 3.35907 24ZM3.35907 1.26316C2.31263 1.26316 1.46433 2.11146 1.46433 3.15789V20.8421C1.46433 21.8885 2.31263 22.7368 3.35907 22.7368H9.04329V1.26316H3.35907ZM10.3064 1.26316V22.7368H21.0433C22.0897 22.7368 22.938 21.8885 22.938 20.8421V3.15789C22.938 2.11146 22.0897 1.26316 21.0433 1.26316H10.3064Z",
    fill: "#3F3F3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideShow);
export default __webpack_public_path__ + "static/media/sideShow.225c1cbb8fdfca28d800a441fb3df43a.svg";
export { ForwardRef as ReactComponent };